// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a3Bv-","background-$(backgroundColor)":"b3Bv-","notResidentBlock":"c3Bv-","x5BankForm":"d3Bv-"};